import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const InventorySyncListTemplate = props => {
	const {
		t,
		viewStore,
		viewStore: {
			loading,
			tableData,
			editField,
			edit,
			cancel,
			update,
			// DO NOT DELETE, USED FOR TABLE RERENDER
			updateTable,
			productInventory,
			onItemChange,
			onCancelBatch,
			allowEdit,
			cancelDisabled,
			openAdjustAllSkusModal
		},
	} = props;
	if (loading) return <Loader />;
	return (
		<section className="flex--vertical flex--grow--1">
			<div className="flex flex--secondary">
				{productInventory.length != 0 && (
					<div className="align--h--right">
						<button
							className="btn btn--med btn--primary spc--bottom--sml spc--right--sml"
							onClick={openAdjustAllSkusModal}
						>
							{t('INVENTORYSYNC.ADJUST.ADJUSTALLSKUS')}
						</button>
						<button
							className="btn btn--med btn--outline spc--bottom--sml spc--right--sml"
							onClick={onCancelBatch}
							disabled={cancelDisabled}
						>
							{t('CANCEL')}
						</button>
					</div>
				)}
			</div>
			<div className="k-grid--inventory-sync k-grid--infinite-scroll">
				<BaasicTable
					listEmptyKey="LISTEMPTY.PRODUCTINVENTORY"
					{...{
						data: productInventory,
						tableData,
						viewStore,
						editField,
						edit,
						cancel,
						update,
						onItemChange,
						allowEdit,
					}}
					rowRender={InventoryDifferenceTableRowRender}
				/>
			</div>
		</section>
	);
};

function InventoryDifferenceTableRowRender(trElement, { dataItem }) {
	const quantityDifferenceStyle =
		dataItem != undefined && dataItem.difference < 0 ? { color: 'red' } : { color: 'green' };
	const onHoldQuantityDifferenceStyle =
		dataItem != undefined && dataItem.warehouseOnHoldQuantityDifference < 0 ? { color: 'red' } : { color: 'green' };
	var mapped = _.map(trElement.props.children, item => {
		if (item.props.field == 'difference') {
			return React.cloneElement(item, { style: quantityDifferenceStyle });
		} else if (item.props.field == 'warehouseOnHoldQuantityDifference') {
			return React.cloneElement(item, { style: onHoldQuantityDifferenceStyle });
		} else return item;
	});
	return <tr>{mapped}</tr>;
}

export default defaultTemplate(InventorySyncListTemplate);
